import React from 'react';
import {Button} from "./Button";

const Alert = (props) => {
    return (
        <div className="modal-container alert-modal">
            <div className={"modal-topline"}>Attention</div>
            <div className="modal-body alert-text">
                {props.text}
            </div>
            <div className="modal-baseline">
                <Button size={"small"}
                        btnStyle={"grey"}
                        onClick={() => props.handleClose()}
                        content={"Annuler"}/>
                <Button size={"small"}
                        btnStyle={"primary-reverse"}
                        onClick={() => props.handleDelete()}
                        content={"Valider"}/>
            </div>
        </div>
    )
};

export default Alert;
